import { useState } from "react";
import { FileText, ChevronUp, ChevronDown, X } from 'lucide-react';
import Modal from "../common/Modal";

export default function CitationsModal({ isOpen, onClose, citations, isLoading }) {
    const [expandedCitations, setExpandedCitations] = useState(new Set());

    const toggleCitation = (index) => {
        const newExpanded = new Set(expandedCitations);
        if (newExpanded.has(index)) {
            newExpanded.delete(index);
        } else {
            newExpanded.add(index);
        }
        setExpandedCitations(newExpanded);
    };

    const truncateText = (text, maxLength = 200) => {
        if (text.length <= maxLength) return text;
        return text.substring(0, maxLength) + '...';
    };

    return (
    <Modal open={isOpen} setOpen={onClose} modalWidth="700px" isDark={true}>
      <div className="p-6">
        <div className="flex justify-between items-center mb-4">
          <h3 className="text-lg font-medium text-white flex items-center gap-2">
            <FileText size={20} />
            Citations & Sources
          </h3>
          <button
            onClick={onClose}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X size={20} />
          </button>
        </div>

        {isLoading ? (
          <div className="flex items-center justify-center py-8">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-500"></div>
            <span className="ml-3 text-gray-300">Loading citations...</span>
          </div>
        ) : citations.length > 0 ? (
          <div className="space-y-4 max-h-96 overflow-y-auto">
            {citations.map((citation, index) => {
              const isExpanded = expandedCitations.has(index);
              const shouldTruncate = citation.extracted_text.length > 200;

              return (
                <div
                  key={index}
                  className="bg-gray-800/50 border border-gray-600 rounded-lg p-4"
                >
                  <div className="flex items-center justify-between mb-2">
                    <div className="flex items-center gap-2">
                      <FileText size={16} className="text-blue-400" />
                      <span className="text-sm font-medium text-blue-300">
                        {citation.metadata.filename}
                      </span>
                    </div>
                    {shouldTruncate && (
                      <button
                        onClick={() => toggleCitation(index)}
                        className="text-gray-400 hover:text-white transition-colors p-1"
                        title={isExpanded ? "Collapse" : "Expand"}
                      >
                        {isExpanded ? <ChevronUp size={16} /> : <ChevronDown size={16} />}
                      </button>
                    )}
                  </div>
                  <div className="text-gray-300 text-sm leading-relaxed">
                    {shouldTruncate && !isExpanded 
                      ? truncateText(citation.extracted_text)
                      : citation.extracted_text
                    }
                  </div>
                  {shouldTruncate && !isExpanded && (
                    <button
                      onClick={() => toggleCitation(index)}
                      className="text-blue-400 hover:text-blue-300 text-xs mt-2 transition-colors"
                    >
                      Show more
                    </button>
                  )}
                </div>
              );
            })}
          </div>
        ) : (
          <div className="text-center py-8">
            <FileText size={48} className="mx-auto text-gray-600 mb-3" />
            <p className="text-gray-400">No citations available for this message.</p>
          </div>
        )}

        <div className="flex justify-end mt-6">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-gray-700 text-white rounded-md hover:bg-gray-600 transition-colors"
          >
            Close
          </button>
        </div>
      </div>
    </Modal>
  );
}